import { render, staticRenderFns } from "./HirebotModelPrice.vue?vue&type=template&id=4c96ea09&scoped=true&"
import script from "./HirebotModelPrice.vue?vue&type=script&lang=js&"
export * from "./HirebotModelPrice.vue?vue&type=script&lang=js&"
import style0 from "./HirebotModelPrice.vue?vue&type=style&index=0&id=4c96ea09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96ea09",
  null
  
)

export default component.exports